import { render, staticRenderFns } from "./collectCreation.vue?vue&type=template&id=f9be84ea&scoped=true"
import script from "./collectCreation.vue?vue&type=script&lang=js"
export * from "./collectCreation.vue?vue&type=script&lang=js"
import style0 from "./collectCreation.vue?vue&type=style&index=0&id=f9be84ea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9be84ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9be84ea')) {
      api.createRecord('f9be84ea', component.options)
    } else {
      api.reload('f9be84ea', component.options)
    }
    module.hot.accept("./collectCreation.vue?vue&type=template&id=f9be84ea&scoped=true", function () {
      api.rerender('f9be84ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/collectCreation.vue"
export default component.exports